import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  TextField,
  Box,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

/**
 * Dialog for editing subscription meta_data JSON.
 * Use in admin subscription detail.
 */
export default function EditMetaDataDialog({
  open,
  onClose,
  value,
  onValueChange,
  onSave,
  loading = false,
  error = null,
  source = "",
}) {
  const isSquarespace = String(source || "").toLowerCase() === "squarespace";

  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Edit Meta Data</DialogTitle>
      <DialogContent dividers>
        {isSquarespace && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Do not remove{" "}
            <Box component="code" sx={{ fontFamily: "monospace", fontSize: "0.85em", bgcolor: "action.hover", px: 0.5, py: 0.25, borderRadius: 0.5 }}>
              squarespace_subscription_id
            </Box>
            ,{" "}
            <Box component="code" sx={{ fontFamily: "monospace", fontSize: "0.85em", bgcolor: "action.hover", px: 0.5, py: 0.25, borderRadius: 0.5 }}>
              squarespace_customer_id
            </Box>
            ,{" "}
            <Box component="code" sx={{ fontFamily: "monospace", fontSize: "0.85em", bgcolor: "action.hover", px: 0.5, py: 0.25, borderRadius: 0.5 }}>
              squarespace_order_id
            </Box>
            , or{" "}
            <Box component="code" sx={{ fontFamily: "monospace", fontSize: "0.85em", bgcolor: "action.hover", px: 0.5, py: 0.25, borderRadius: 0.5 }}>
              pricingId
            </Box>
            . They are required for cancel and reactivate.
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          fullWidth
          multiline
          minRows={10}
          maxRows={20}
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          placeholder='{"key": "value"}'
          sx={{
            "& textarea": { fontFamily: "monospace", fontSize: "0.875rem" },
          }}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => !loading && onClose()}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <EditIcon />
            )
          }
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
